const isValidEmail = (emailAddress: string | null | undefined) => {
  if (!emailAddress) return false;
  const emailRegex = emailAddress
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  return emailRegex !== null;
};

const isValidPassword = (password: string | null | undefined) => {
  if (!password) return false
  // at least 8 characters long and
  // at least: 1 uppercase, 1 lowercase, 1 digit and 1 symbol
  const regex = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^$*.[\]{}()?\-"!@#%&/,><':;|_~`+=])[A-Za-z\d^$*.[\]{}()?\-"!@#%&/,><':;|_~`+=]{8,}/
  return regex.test(password)
}

/**
 * Shared date/time formatter — dd/mm/yyyy, HH:mm, 24h, Israel timezone.
 * Accepts ISO strings (with or without Z suffix) or numeric timestamps.
 * Returns empty string on invalid input.
 */
const formatDateTime = (input: string | number): string => {
  try {
    let date: Date
    if (typeof input === 'number') {
      date = new Date(input)
    } else {
      const normalized = input.endsWith('Z') || input.includes('+') ? input : input + 'Z'
      date = new Date(normalized)
    }
    if (isNaN(date.getTime())) return ''
    return date.toLocaleString('en-GB', {
      timeZone: 'Asia/Jerusalem',
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false,
    })
  } catch { return '' }
}

// Legacy aliases — delegate to formatDateTime
const getDateStr = (isoStr: string) => {
  const separator = isoStr.includes("T") ? "T" : " ";
  const dateSplit = isoStr.split(separator)[0].split("-");
  return dateSplit.reverse().join("/");
};

const getTimeStr = (isoStr: string) => {
  const separator = isoStr.includes("T") ? "T" : " ";
  return isoStr.split(separator)[1].substring(0, 8);
};

const getDateTimeStr = (isoStr: string) => formatDateTime(isoStr) || null;

const timestampToDateStr = (timestamp: number) => formatDateTime(timestamp);

const dateStrToDateStr = (dateStr: string) => formatDateTime(dateStr);

const isArrayElementsEqual = (arr1: any[], arr2: any[]) => {
  if (arr1.length !== arr2.length) return false;
  const set1 = new Set(arr1);
  for (let i = 0; i < arr2.length; i++) {
    if (!set1.has(arr2[i])) return false;
  }
  return true;
};


const getCellValue = (item: any, itemMapping: any) => {
  const valueLocation = itemMapping.location
  const type = itemMapping.type
  const trueText = itemMapping.trueText
  const falseText = itemMapping.falseText
  let value: any = {}
  const locationDepth = valueLocation.length
  let i = 0
  if (!item) {
    return
  }
  while (i < locationDepth) {
    if (i === 0) {
      value = item[valueLocation[i]] ? item[valueLocation[i]] : ''
      i++
    } else {
      value = value[valueLocation[i]] ? value[valueLocation[i]] : ''
      i++
    }
  }
  if (type === 'boolean') {
    return (value ? trueText : falseText)
  }
  return (value)
}

const capitalizeFirstLetter = (string: string) =>{
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const utilService = {
  isValidEmail,
  isValidPassword,
  formatDateTime,
  getDateStr,
  getTimeStr,
  getDateTimeStr,
  timestampToDateStr,
  dateStrToDateStr,
  isArrayElementsEqual,
  getCellValue,
  capitalizeFirstLetter
};
